import {
  DASHBOARD_OVERTIME_FETCHING,
  DASHBOARD_OVERTIME_FAILED,
  DASHBOARD_OVERTIME_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DASHBOARD_OVERTIME_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DASHBOARD_OVERTIME_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DASHBOARD_OVERTIME_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}